(function() {
  const STORAGE_KEY = 'collectionView'; // 'grid' | 'list'

  function getGridEl() {
    return document.querySelector('#product-grid');
  }

  function getButtons() {
    return document.querySelectorAll('.view-toggle__btn');
  }

  function applyView(view) {
    const grid = getGridEl();
    if (!grid) return;

    if (view === 'list') {
      grid.classList.add('list-view');
    } else {
      grid.classList.remove('list-view');
    }

    // Botones activos + aria
    getButtons().forEach(btn => {
      const isActive = btn.getAttribute('data-view') === view;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
    });
  }

  function updateURL(view) {
    try {
      const url = new URL(location.href);
      url.searchParams.set('view', view);
      history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function saveView(view) {
    try { localStorage.setItem(STORAGE_KEY, view); } catch(e) {}
    updateURL(view);
  }

  function readViewFromURL() {
    const p = new URLSearchParams(location.search);
    const v = p.get('view');
    return (v === 'list' || v === 'grid') ? v : null;
  }

  function readView() {
    const fromURL = readViewFromURL();
    if (fromURL) return fromURL;
    try { return localStorage.getItem(STORAGE_KEY) || 'grid'; } catch(e) { return 'grid'; }
  }

  function initButtons() {
    getButtons().forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.getAttribute('data-view');
        saveView(view);
        applyView(view);
      });
    });
  }

  // Reaplicar al re-render (AJAX de filtros/paginación de Dawn)
  function observeGridContainer() {
    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    const reapply = () => {
      applyView(readView());
      initButtons(); // por si el toolbar fue re-renderizado
    };

    const mo = new MutationObserver(() => {
      clearTimeout(observeGridContainer._t);
      observeGridContainer._t = setTimeout(reapply, 50);
    });
    mo.observe(container, { childList: true, subtree: true });

    document.addEventListener('facets:updated', reapply);
    document.addEventListener('shopify:section:load', reapply);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    applyView(readView());
    observeGridContainer();
  });
})();